import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import { Title, SimpleForm, FileInput, SelectInput, FileField, required } from 'react-admin';
import Button from '@material-ui/core/Button';
import UploadFileToolbar from 'components/UploadFileToolbar';

const TemplateField = ({ url, record = {} }) => (
  <Button color="primary" variant="outlined" href={url} target="_blank">
    Link
  </Button>
);
TemplateField.defaultProps = { addLabel: true, label: 'Template URL' };

const modelTemp = process.env.REACT_APP_TEMP_IMPORT_MODEL;
const consTemp = process.env.REACT_APP_TEMP_IMPORT_CONS;
const custTemp = process.env.REACT_APP_TEMP_IMPORT_CUST;

class ImportFile extends Component {
  state = {
    permissions: null,
    key: false,
    url: false,
  };

  static getDerivedStateFromProps(props, state) {
    if (props.permissions !== state.permissions) {
      return {
        permissions: props.permissions,
      };
    }

    return null;
  }

  handleChangeKey = (e, value) => {
    this.setState({ key: value });
    let url = false;
    if (value) {
      switch (value) {
        case 'cars':
          url = modelTemp;
          break;
        case 'staffs':
          url = consTemp;
          break;
        case 'customers':
          url = custTemp;
          break;
        default:
          url = false;
      }
      this.setState({ url: url });
    }
  };

  checkPermission = permissions => {
    if (permissions !== null) {
      if (permissions.importfiles === undefined) {
        return [{ id: 'cars', name: 'Models' }];
      }
      return [
        { id: 'cars', name: 'Models' },
        { id: 'staffs', name: 'Consultants' },
        { id: 'customers', name: 'Customers' },
      ];
    }
  };

  render() {
    const { ...props } = this.props;
    const { key, url, permissions } = this.state;
    return (
      <Card {...props}>
        <Title title="Import Files" />
        <SimpleForm toolbar={<UploadFileToolbar source="file_url" redirectTo="/importfiles" />}>
          <SelectInput
            source="key"
            onChange={this.handleChangeKey}
            choices={this.checkPermission(permissions)}
            validate={required()}
          />

          {key && <TemplateField url={url} />}

          <FileInput
            source="file"
            label="File"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            validate={required()}
          >
            <FileField source="src" title="title" />
          </FileInput>
        </SimpleForm>
      </Card>
    );
  }
}

export default ImportFile;



// WEBPACK FOOTER //
// ./src/containers/ImportFile/index.js